// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layouts-default-body-fltwt{min-width:1240px}.layouts-default-body-fltwt a:hover{color:var(--color-primary-hover)}.layouts-default-layout-sfypb{display:flex;flex-direction:column;min-height:100vh;padding-left:50px!important;padding-right:50px!important}.layouts-default-nuxt-rihlq{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "layouts-default-body-fltwt",
	"layout": "layouts-default-layout-sfypb",
	"nuxt": "layouts-default-nuxt-rihlq"
};
module.exports = ___CSS_LOADER_EXPORT___;
